import { BaseTable } from "../BaseTable/BaseTable";
import { useList } from "src/hooks/useFetch.hook";
import { ProductCatalogListColumns } from "./Product.constants";
import { useNavigate } from "react-router-dom";

const ProductCatalogList = ({ isReadOnly }) => {
    const navigate = useNavigate();
    const { data: product, isFetching } = useList("productCatalog");

    const rowOrCellClickRedirect = ({ id }) => {
        navigate(`/product-listing/${id}`);
      };

    return (
        <BaseTable
            rows={product ?? []}
            columns={ProductCatalogListColumns()}
            loading={isFetching}
            getRowId={(row) => row.id}
            rowOrCellClickRedirect={rowOrCellClickRedirect}
            isReadOnly={isReadOnly}
        />
    );
}

export default ProductCatalogList;